"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _alloyReactTheme = _interopRequireDefault(require("@adsk/alloy-react-theme"));
var _alloyReactButton = _interopRequireDefault(require("@adsk/alloy-react-button"));
var _alloyReactTextInput = _interopRequireDefault(require("@adsk/alloy-react-text-input"));
var _alloyReactTooltip = _interopRequireDefault(require("@adsk/alloy-react-tooltip"));
var _i18n = require("../../../i18n");
var _QuickReportsPanelContext = _interopRequireDefault(require("../QuickReportsPanelContext"));
var _hooks = require("../hooks");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const SuccessPanelBody = _ref => {
  let {
    reportUrl
  } = _ref;
  const textInputRef = (0, _react.useRef)();
  const {
    T
  } = (0, _i18n.useTranslation)();
  const {
    reportService,
    reportType,
    reportFormat
  } = (0, _react.useContext)(_QuickReportsPanelContext.default);
  const {
    trackCopyLink
  } = (0, _hooks.useTrackEvent)({
    reportService,
    reportType,
    reportFormat
  });
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(DownloadLinkMessage, null, T.translate('notifications.downloadLink')), /*#__PURE__*/_react.default.createElement(DownloadPromptMessage, null, T.translate('notifications.downloadPrompt')), /*#__PURE__*/_react.default.createElement(InputContainer, null, /*#__PURE__*/_react.default.createElement(StyledTextInput, {
    ref: textInputRef,
    readOnly: true,
    value: reportUrl
  }), /*#__PURE__*/_react.default.createElement(_alloyReactTooltip.default, {
    content: T.translate('tooltips.linkCopied'),
    placement: _alloyReactTooltip.default.PLACEMENTS.TOP,
    trigger: _alloyReactTooltip.default.TRIGGER_EVENTS.CLICK,
    triggerTarget: _alloyReactTooltip.default.TRIGGER_TARGETS.CHILDREN
  }, /*#__PURE__*/_react.default.createElement(CopyButton, {
    onClick: () => {
      const textInput = textInputRef.current;
      if (textInput) {
        trackCopyLink();
        textInput.select();
        document.execCommand('copy');
      }
    }
  }, T.translate('button.copyLink')))));
};
const DownloadLinkMessage = (0, _styledComponents.default)(_styledComponents.default.p(_alloyReactTheme.default.typography.heading4))`
  margin-bottom: 8px;
  align-self: start;
`;
const DownloadPromptMessage = (0, _styledComponents.default)(_styledComponents.default.span(_alloyReactTheme.default.typography.bodySmall))`
  color: ${_alloyReactTheme.default.colors.charcoal700};
`;
const StyledTextInput = (0, _styledComponents.default)(_alloyReactTextInput.default)`
  height: 100%;
  input {
    box-sizing: border-box;
  }
`;
const CopyButton = (0, _styledComponents.default)(_alloyReactButton.default)`
  height: 100%;
  min-width: 115px;
`;
const InputContainer = _styledComponents.default.div`
  display: flex;
  margin-top: 10px;
  width: 100%;
  min-height: 36px;
`;
SuccessPanelBody.propTypes = {
  reportUrl: _propTypes.default.string
};
var _default = exports.default = SuccessPanelBody;